import angular from 'angular';

angular.module('cloudX').factory('relationDialogsSvc', ['$q', 'ModalService', relationDialogsSvc]);

// Exposes relation dialogs as a service so React screens can open them by receiving this service
// as a prop (see the react2angular registrations in components.js).
function relationDialogsSvc($q, ModalService) {
  function showModal(modalOptions) {
    var deferred = $q.defer();
    ModalService.showModal(modalOptions).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) deferred.resolve(result);
        else deferred.reject(null);
      }, deferred.reject);
    }, deferred.reject);
    return deferred.promise;
  }

  return {
    // Resolves when the deviations were saved, rejects when the dialog was cancelled.
    showTaskScheduleDeviations: function(taskScheduleId) {
      return showModal({
        template: require('./taskScheduleDeviationsDialog.html'),
        controller: 'TaskScheduleDeviationsDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          schedule: { id: taskScheduleId },
        },
      });
    },
  };
}
